<p>detail-type-vehicule-auto works!</p>
